import { Button, TextButton } from "@amzn/storm-ui";
import ReactMarkdown from "react-markdown";
import styled, { css } from "styled-components";

export const AppContainer = styled.section<{
    pixelsToRemove: number;
}>`
    max-height: ${(props) => `calc(100vh - ${props.pixelsToRemove}px)`};
`;

export const DivFlexSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const DivFlexJustifyLeft = styled.div`
    display: flex;
    justify-content: left;
`;

export const DivFlexJustifyRight = styled.div`
    display: flex;
    justify-content: right;
`;

export const DivFlexAlignCenter = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const DivJustifyItemCenter = styled.div`
    justify-items: center;
`;

export const DivAlignContentCenter = styled.div`
    align-content: center;
`;

export const DivFlexAlignStretch = styled.div`
    display: flex;
    gap: 10px;
    align-items: stretch;
`;

export const DivFlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DivPadded = styled.div`
    padding: 10px;
`;

export const FullHeightDivFlexCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    min-height: 15vh;
`;

export const DivFlexCenterFullHeight = styled.div`
    align-items: center;
    height: 100%;
    display: flex;
    justify-content: center;
`;

export const OverflowOverlaySection = styled.section<{
    pixelsToRemove: number;
}>`
    overflow: overlay;
    height: ${(props) => `calc(100vh - ${props.pixelsToRemove}px)`};
`;

export const FullHeightDiv = styled.div<{ paddingInPx?: number }>`
    height: 100%;
    padding: ${(props) => `${props.paddingInPx ?? 0}px`};
`;

export const ComponentLabel = styled.span`
    display: inline;
    font-size: 13px;
    line-height: 1.465;
    font-family: "Amazon Ember", Helvetica, sans-serif;
    padding: 0px;
    font-weight: 700;
    color: rgb(35, 47, 63);
`;

export const SpaceBetweenAlignedDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px;
`;

// Move these to its own file in next CR
export const TopBar = styled.div`
    position: sticky;
    top: 0;
    padding: 10px;
    background-color: white;
    border-bottom: 2px solid #d9dee4;
    z-index: 1;
`;

export const OptionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: end;
`;

export const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 25vw;
    padding: 10px 5%;
    gap: 20px;
`;

export const ModalContentContainer = styled.div`
    width: 30vw;
`;

export const ModalFooterCancelButton = styled(TextButton)`
    margin-right: ${({ theme }) => theme.spacing.small.default};
`;

export const ModalFooterContainer = styled.div`
    display: flex;
`;

export const InputComponentTextButton = styled(TextButton)<{
    hasLabel?: boolean;
}>`
    flex: none;
    ${(props) =>
        props.hasLabel &&
        css`
            margin-top: ${({ theme }) => theme.spacing.medium.default};
        `}
`;

export const InputComponentButton = styled(Button)`
    flex: none;
    align-self: end;
`;

export const AccountPickerFooterWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`;

export const AccountSwitcherContainer = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
`;

export const AccountSwitcherWrapper = styled.div<{ width?: number }>`
    width: ${(props) => (props.width ? `${props.width}px` : "300px")};
`;

export const ToolbarButton = styled(Button)`
    :first-of-type {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    :last-of-type {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    :only-child {
        border-top-right-radius: 999px;
        border-bottom-right-radius: 999px;
        border-top-left-radius: 999px;
        border-bottom-left-radius: 999px;
    }
`;

export const ToolbarButtonGroup = styled.div`
    display: flex;
    gap: 3px;
`;

export const DeepLinkContainer = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: 24px;
    background-color: ${({ theme }) => theme.color.gray[50]};
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.color.gray[200]};
`;

export const DeepLinkHeader = styled.div`
    margin-bottom: 24px;
    text-align: center;
`;

export const DeepLinkHeaderText = styled.div`
    font-size: 18px;
    font-weight: bold;
`;

export const DeepLinkTemplateInfo = styled.div`
    margin-bottom: 16px;
`;

export const DeepLinkTemplateDescription = styled.div`
    margin-top: 8px;
`;

export const DeepLinkAlertContainer = styled.div`
    margin-top: 12px;
`;

export const DeepLinkFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
`;

export const DeepLinkStepText = styled.div`
    margin-top: 4px;
`;

export const DeepLinkAccessDeniedContainer = styled.div`
    margin-top: 12px;
`;

export const DeepLinkNoAccountsSteps = styled.div`
    margin-top: 8px;
`;

export const CardContainer = styled.div`
    display: block;
    margin: 50px auto;
    max-width: 900px;
`;

export const Markdown = styled(ReactMarkdown)`
    font: ${({ theme }) => theme.font.text.base.default};
    p {
        margin: 0px;
    }
`;
